export default __webpack_public_path__ + "static/media/img-42.1f2af20c.jpg";